import React, { Component } from 'react';
import { Input, Button, Card, Tabs, Statistic, List, Icon } from 'antd';
import { getChatbotAccount, getPlans, processTransaction, setSubscription, setBlockAccount, deleteBlockAccount } from 'services/CeberusApiService';
import { MODAL_TYPES, ModalFactory } from 'components/ModalFactory';
import { GridView } from 'models/GridView';
import { PushNotification } from 'utils/PushNotification';
import { Tenant } from 'models/Blip/Index';
import { TenantService } from 'connection/TenantService';
import { BillingPlansResponse } from 'models/response/BillingPlansResponse';
import { SearchOrganizationRequest } from 'models/request/SearchOrganizationRequest';
import { BaseRequest ,SubscriptionRequest, AccountRequest ,TransactionRequest } from 'models/request/Index';
import BlockAccountButton from 'components/BlockAccountButton';
  
const TabPane = Tabs.TabPane
const { Search } = Input
const ListItem = List.Item
const ListItemMeta = List.Item.Meta
const DOMAIN_BLIP_AI = '@blip.ai';

export class Account extends Component<BaseRequest> {

    state = {
      isLoading: false,
      isSearchDisabled: false,
      isLoadingButtonSearch: false,
      searchingIdentifier: '',
      plans: new Array<BillingPlansResponse>(),
      currentUser: undefined,
      userBalance: 0,
      cardLoading: false,
      currentOperation: 'credit',
      walletId: '',
      identifier: '',
      isModalVisible: false,
      editingRecord: {},
      currentModal: '',
      isModalLoading: false,
      bots: [],
    }

    formRef: any;
    tenantSelected: Tenant;

    async componentDidMount() {
      await this.loadPage();
    }

    loadPage = async () : Promise<void> => {
      this.tenantSelected = TenantService.getSelectedTenant();

      const searchOrganizationRequest = new SearchOrganizationRequest();
      searchOrganizationRequest.ClusterName = this.tenantSelected.name;
      const plans = await getPlans(searchOrganizationRequest);
      this.setState({ plans })  
    }

    setComponentLoading(isLoading: boolean) : void {
      this.setState({ isLoading })
    }

    saveFormRef = (formRef : any) : void => {
      this.formRef = formRef
    }

    getAccount = async (identifier : string) : Promise<void> => {
      this.setState({ cardLoading: true })
      const data = await getChatbotAccount(new AccountRequest(identifier, this.tenantSelected.name));

      this.setState({ 
        currentUser: { 
          ...data.Account, 
          activeSubscription: { ...data.Subscription }, 
          balance: data.Balance,
          BlockAccountStatus: data.BlockAccountStatus
        }, 
        walletId: data.WalletId,
        bots: data.Applications 
      });

      this.setState({ cardLoading: false })
    }

    onSearch = async (identifier : string) : Promise<void> => {
      if (identifier == undefined || identifier == '') {
        return
      }
    
      try {

        this.setComponentLoading(true);
        this.setState({ identifier, isLoadingButtonSearch: true });
        await this.getAccount(identifier);

      } catch (error) {

        this.state.identifier = ''
        this.state.currentUser = undefined
        PushNotification.httpError(error);

      } finally {
        this.setComponentLoading(false);
        this.setState({ isLoadingButtonSearch: false })
      }
    }

    setAccount = async (accountIdentity: string , accountPlan: string) : Promise<void> => {
      try {
        this.setComponentLoading(true);
        const request = new SubscriptionRequest();
        request.ClusterName = this.tenantSelected.name;
        request.PaymentAccount = accountIdentity;
        request.PlanId = accountPlan;
        const response = await setSubscription(request);
        await this.getAccount(this.state.identifier);
        PushNotification.success(response);
      } catch (error) {
        PushNotification.httpError(error);
      } finally {
        this.setComponentLoading(false);
      }
    }

    processTransaction = async (type: string, value: number) : Promise<void> => {
      try {
        const { walletId } = this.state
        this.setComponentLoading(true);
        const request = new TransactionRequest();
        request.ClusterName = this.tenantSelected.name;
        request.WalletId =  walletId;
        request.Type =  type;
        request.Amount = value;
        const response = await processTransaction(request);
        await this.getAccount(this.state.identifier)
        PushNotification.success(response);
      } 
      catch (error) {
        PushNotification.httpError(error);
      } finally {
        this.setComponentLoading(false);
      }
    }

    blockAccount = async () => {
      try {
        this.setComponentLoading(true);
        const request = new AccountRequest(this.state.currentUser.email, this.tenantSelected.name);
        await setBlockAccount(request);
        await this.getAccount(this.state.identifier);
        PushNotification.success('Account blocked successfully!');
      } catch (error) {
        PushNotification.httpError(error);
      } finally {
        this.setComponentLoading(false);
      }
    }

    unblockAccount = async () => {
      try {
        this.setComponentLoading(true);
        const request = new AccountRequest(this.state.currentUser.email, this.tenantSelected.name);
        await deleteBlockAccount(request);
        await this.getAccount(this.state.identifier);
        PushNotification.success('Account unblocked successfully!');
      } catch (error) {
        PushNotification.httpError(error);
      } finally {
        this.setComponentLoading(false);
      }
    }

    handleModalVisibility = (type: string, visibility: boolean) : void => {
      switch(type) {
        case MODAL_TYPES.EditAccountPlan :
        case MODAL_TYPES.PerformTransaction :
          this.setState({ isModalVisible: visibility, currentModal: type })
          if (!visibility) {
            this.setState({ editingRecord: {} })
          }
          break
        default:
          PushNotification.error('Unrecognized modal type');
      }
    }

    handleOnOpenModal = (record: any, type: string) : void => {
      this.setState({ editingRecord: record, currentModal: type })
      this.handleModalVisibility(type, true)
    }

    handleOnOkModal = (type: string) : void => {
      this.setState({ isModalLoading: true });
    
      const form = this.formRef.props.form;

      form.validateFields(async (err, values) => {
        if (err) {
          this.setState({ isModalLoading: false })
          return
        }
    
        try {
          switch (type) {
            case MODAL_TYPES.EditAccountPlan: {
              const { accountPlan } = values;
              await this.setAccount(this.state.currentUser.identity.Name, accountPlan)
              break
            }

            case MODAL_TYPES.PerformTransaction: {
              const { operation, amount } = values;
              await this.processTransaction(operation, amount)
              break
            }

            default:
              PushNotification.error('Ops! We had a problem! See on the console.');
              break
          }
    
          form.resetFields()
          this.setState({ isModalVisible: false, editingRecord: {}, })
        } catch(error) {
          PushNotification.httpError(error);
        } finally {
          this.setState({ isModalLoading: false });
        }
      })
    }

  getOverviewList = () : Array<GridView> => {
    if (this.state.currentUser) {
      const { BlockAccountStatus } = this.state.currentUser;
      return [
        {
          title: 'Identity:',
          description: this.state.currentUser.identity ? this.state.currentUser.identity.Name.replace(DOMAIN_BLIP_AI) : ''
        },
        {
          title: 'Email:',
          description: this.state.currentUser.email,
        },
        {
          title: 'Culture:',
          description: this.state.currentUser.culture,
        },
        {
          title: 'Full Name:',
          description: this.state.currentUser.fullName,
        },
        {
          title: 'Phone Number:',
          description: this.state.currentUser.phoneNumber,
        },
        {
          title: 'Is Blocked:',
          description: (
            <span>
              {BlockAccountStatus.IsBlocked ? 'Yes' : 'No'}
              <BlockAccountButton
                isBlocked={BlockAccountStatus.IsBlocked}
                isLoading={this.state.isLoading}
                onBlock={this.blockAccount}
                onUnblock={this.unblockAccount}
              />
            </span>
          )
        }
      ]
    }

    return []
  }

  getBillingList = () : Array<GridView> => {
    if (this.state.currentUser) {
      const currentPlanName = this.state.plans != undefined && this.state.currentUser.activeSubscription.PlanId != undefined
        ? this.state.plans.find(plan => { return plan.id == this.state.currentUser.activeSubscription.PlanId }).name
        : 'no data'
      const currentBalance = this.state.currentUser.balance != undefined
        ? '' + this.state.currentUser.balance
        : 'no data'

      return [
        {
          title: 'Plan:',
          description: [
            <span style={{ fontSize: '16px', lineHeight: '36px' }}>
              {currentPlanName}
            </span>,
            <Button
              key="editPlanButton"
              type="primary"
              shape="round"
              size="small"
              icon="edit"
              className="ml4"
              onClick={() => this.handleOnOpenModal({ plans: this.state.plans }, MODAL_TYPES.EditAccountPlan)}>
              Change Plan
            </Button>
          ]
        },
        {
          title: 'Balance:',
          description: [
            <div key="balance-wrapper" className="flex items-baseline">
              <Statistic
                key="balance"
                value={currentBalance}
                precision={2} />
              <Button
                key="credit"
                type="primary"
                shape="round"
                size="small"
                icon="swap"
                className="ml4"
                onClick={() => this.handleOnOpenModal({}, MODAL_TYPES.PerformTransaction)}>
                Add or remove Credits
              </Button>
            </div>
          ],
        }

      ]
    }

    return []
  }

  getCurrentSubscriptionList = () : Array<GridView> => {
    if (this.state.currentUser) {
      return [
        {
          title: 'Subscriber:',
          description: this.state.currentUser.activeSubscription.Subscriber,
        },
        {
          title: 'Start Date:',
          description: this.state.currentUser.activeSubscription.StartDate,
        },
        {
          title: 'Last Change Date:',
          description: this.state.currentUser.activeSubscription.LastChangeDate,
        },
        {
          title: 'Is Pending:',
          description: this.state.currentUser.activeSubscription.IsPending == undefined
            ? 'no data'
            : this.state.currentUser.activeSubscription.IsPending === true
              ? 'true'
              : 'false',
        },
        {
          title: 'Is Active:',
          description: this.state.currentUser.activeSubscription.IsActive == undefined
            ? 'no data'
            : this.state.currentUser.activeSubscription.IsActive === true
              ? 'true'
              : 'false',
        }
      ]
    }

    return []
  }

  render() {
    const { cardLoading } = this.state

    const overviewItems = this.getOverviewList()
    const billingItems = this.getBillingList()
    const currentSubscriptionItems = this.getCurrentSubscriptionList()

    const overviewTab = () => (
      <div>
        <Card title="BLiP Account Information" loading={cardLoading}>
          <List
            itemLayout="horizontal"
            dataSource={overviewItems}
            renderItem={item => (
              <ListItem>
                <ListItemMeta
                  title={item.title}
                  description={item.description}>
                </ListItemMeta>
              </ListItem>
            )}>
          </List>
        </Card>
      </div>
    )

    const billingTab = () => (
      <div>
        <Card title="Billing Information" className="mb3" loading={cardLoading}>
          <List
            grid={{ gutter: 16, column: 2 }}
            dataSource={billingItems}
            renderItem={item => (
              <ListItem key={item.title}>
                <Card title={item.title}>
                  {item.description}
                </Card>
              </ListItem>
            )}>
          </List>
        </Card>
        <Card title="Current Subscription Information" loading={cardLoading}>
          <List
            itemLayout="horizontal"
            dataSource={currentSubscriptionItems}
            renderItem={item => (
              <ListItem>
                <ListItemMeta
                  title={item.title}
                  description={item.description}>
                </ListItemMeta>
              </ListItem>
            )}>
          </List>
        </Card>
      </div>
    )

    const botsTab = () => (
      <div>
        <Card title="Bots owned by this account">
          <List
            dataSource={this.state.bots}
            renderItem={item => (
              <ListItem>
                <ListItemMeta
                  key={item.applicationIdentity}
                  description={item.applicationIdentity}
                />
              </ListItem>
            )}
          />
        </Card>
      </div>
    )

    return (
      <div className="flex flex-wrap">
        <div className="tc w-100">
          <h1><Icon type="user" className="mr3" />Search Account by email</h1>
          <Search
            placeholder="Email account"
            enterButton="Search"
            size="large"
            style={{ width: 400 }}
            disabled={this.state.isSearchDisabled}
            loading={this.state.isLoadingButtonSearch}
            onSearch={this.onSearch}
            allowClear
          />
        </div>
        <div className="mt5 w-100">
          {this.state.currentUser && <Tabs defaultActiveKey="1">
            <TabPane tab="Overview" key="1">
              {overviewTab()}
            </TabPane>
            <TabPane tab="Billing" key="2">
              {billingTab()}
            </TabPane>
            <TabPane tab="Bots" key="3">
              {botsTab()}
            </TabPane>
          </Tabs>}
        </div>
        <ModalFactory
          wrappedComponentRef={this.saveFormRef}
          visible={this.state.isModalVisible}
          onCancel={() => this.handleModalVisibility(this.state.currentModal, false)}
          onOk={() => this.handleOnOkModal(this.state.currentModal)}
          loading={this.state.isModalLoading}
          type={this.state.currentModal}
          record={this.state.editingRecord}
          maskClosable={false}
        />
      </div>
    )
  }
}